let watermark = {}

const ElementPageHash = new Map();

const  bodyWaterMarkId = 'userWatermark9999'


function getByteLen(val) {
  let clen = 0;
  let elen = 0
  for (var i = 0; i < val.length; i++) {
    var length = val.charCodeAt(i);
    if(length>=0&&length<=128)
    {
      elen+=1
    }
    else
    {
      clen += 2;
    }
  }
  return [clen,elen];
}

function clearWatermark(){
  ElementPageHash.forEach((value, key) => {
    if(document.getElementById(key)){
      document.getElementById(key).removeChild(document.getElementById(value))
    }else{
      document.body.removeChild(document.getElementById(value))
    }
  })
  ElementPageHash.clear()
}

function removeWatermark() {

  if(document.getElementById(bodyWaterMarkId)){
    document.body.removeChild(document.getElementById(bodyWaterMarkId))
  }

  // if(ElementPageHash.has(el)){
  //     if(document.getElementById(el)){
  //         document.getElementById(el).removeChild(document.getElementById(ElementPageHash.get(el)))
  //     }else{
  //         console.log(ElementPageHash.get(el))
  //         console.log(document.getElementById(ElementPageHash.get(el)))
//             document.body.removeChild(document.getElementById(ElementPageHash.get(el)))
//         }
//         ElementPageHash.delete(el)
//     }
// }
}

let setWatermark = (setting,element = null,id=null) => {
  let args = Object.assign({},setting)

  id = bodyWaterMarkId

  // if(!id) {
  //     id = Math.floor(Math.random() * (10000 - 1)) + 1;
  //     if(!element){
  //         ElementPageHash.set('body',id)
  //     }else{
  //         ElementPageHash.set(element,id)
  //     }
  // }
  // if (document.getElementById(id) !== null) {
  //     if(!element) {
  //         document.body.removeChild(document.getElementById(id))
  //         if(ElementPageHash.has('body')){
  //             ElementPageHash.delete('body')
  //         }
  //     }else{
  //         document.getElementById(element).removeChild(document.getElementById(id))
  //         if(ElementPageHash.has(element)){
  //             ElementPageHash.delete(element)
  //         }
  //     }
  //
  // }


  //默认设置
  let defaultSettings={
    watermark_txt:"我是水印",
    watermark_x:-20,//水印起始位置x轴坐标
    watermark_y:10,//水印起始位置Y轴坐标
    watermark_color:'#AAAAAA66',//水印字体颜色
    watermark_alpha:1,//水印透明度
    watermark_fontsize:'15px',//水印字体大小
    watermark_font:'微软雅黑',//水印字体
    watermark_width:510,//水印宽度
    watermark_height:180,//水印高度
    watermark_angle:0//水印倾斜度数 -180 ~ 180
  };
  let textLen = getByteLen(args.watermark_txt)[0]/2 //args.watermark_txt.length


  if(textLen < 5 && getByteLen(args.watermark_txt)[1] < 30) {
    args.watermark_width = 300
    args.watermark_height = 120
  }


  if(args.watermark_angle != 1) {
    args.watermark_angle = 0
    if(textLen > 15　&& args.watermark_fontsize > 15) {
      args.watermark_width = 500 + (textLen-15) * args.watermark_fontsize
    }
    args.watermark_fontsize = args.watermark_fontsize +'px'
    args.watermark_y = defaultSettings.watermark_height/2
    args.watermark_x = 10

  }else{
    args.watermark_angle = -16
    //在这里处理下几种情况
    //setp1在这里处理汉字大于12,且字体在20以上的问题
    if(textLen > 12　&& args.watermark_fontsize > 20) {
      args.watermark_width = 400 + (textLen-12) * args.watermark_fontsize
      args.watermark_height = 160 +  Math.ceil((textLen-12)/5) * args.watermark_fontsize

      if( args.watermark_fontsize >29) {
        args.watermark_width = 500 + (textLen-12) * args.watermark_fontsize
        if(args.watermark_fontsize > 13) {
          args.watermark_height = 160 + Math.ceil((textLen-13)/3) * args.watermark_fontsize
        }
      }
    }

    if(textLen < 12　&&  args.watermark_fontsize > 27){
      args.watermark_width = 400 + 1 * args.watermark_fontsize
      args.watermark_height = 160 + 1 *  args.watermark_fontsize
    }

    args.watermark_y = args.watermark_fontsize
    args.watermark_x = -args.watermark_fontsize+5
    args.watermark_fontsize = args.watermark_fontsize +'px'
  }




  if(typeof args ==="object" )
  {
    let src= args||{};
    for(let keyS in src)
    {
      if(src[keyS]&&defaultSettings[keyS]&&src[keyS]===defaultSettings[keyS])
        continue;
      else if(src[keyS])
        defaultSettings[keyS]=src[keyS];
    }
  }



  //创建一个画布
  let can = document.createElement('canvas')
  //设置画布的长宽
  can.width = defaultSettings.watermark_width
  can.height = defaultSettings.watermark_height

  let cans = can.getContext('2d')
  //旋转角度
  if(defaultSettings.watermark_angle) {
    cans.rotate(defaultSettings.watermark_angle * Math.PI / 180)
  }

  cans.font = defaultSettings.watermark_fontsize+ " "+ defaultSettings.watermark_font


  //设置填充绘画的颜色、渐变或者模式
  cans.fillStyle =  defaultSettings.watermark_color
  // cans.globalAlpha=0.4;
  // cans.fillStyle = 'rgba(200, 200, 200, 0.40)'
  //设置文本内容的当前对齐方式
  cans.textAlign = 'left'
  //设置在绘制文本时使用的当前文本基线
  cans.textBaseline = 'Middle'
  //在画布上绘制填色的文本（输出的文本，开始绘制文本的X坐标位置，开始绘制文本的Y坐标位置）
  cans.fillText(defaultSettings.watermark_txt, defaultSettings.watermark_x, can.height-defaultSettings.watermark_y)
  // cans.fillText(defaultSettings.watermark_txt, 40, 60)
  // console.log(cans)
  let div = document.createElement('div')
  div.id = id
  div.style.pointerEvents = 'none'
  div.style.top = '0px'
  div.style.left = '0px'
  div.style.position = 'fixed'
  div.style.zIndex = '100000'
  div.style.width = document.documentElement.clientWidth + 'px'
  div.style.height =  document.body.scrollHeight + 'px' // document.documentElement.clientHeight + 'px'
  div.style.background = 'url(' + can.toDataURL('image/png') + ') left top repeat'
  // document.body.appendChild(div)
  div.style.opacity = defaultSettings.watermark_alpha // 水印的透明度

  if(element) {
    document.getElementById(element).appendChild(div)
  }else{
    div.style.top = '0px'
    document.body.appendChild(div)
  }
  // let show = document.getElementById("app") // 控制水印显示的区域，设置id = show,表示在该范围内有水印
  //
  // show.appendChild(div)
  return id
}

// 该方法只允许调用一次
watermark.set = (args,element) => {
  let id = setWatermark(args,element)
  // setInterval(() => {
  //     if (document.getElementById(id) === null) {
  //         id = setWatermark(str)
  //     }
  // }, 500);
  // window.onresize = () => {
  //     // if(!element){
  //     //     removeWatermark('body')
  //     // }else{
  //     //     removeWatermark(element)
  //     // }
  //     removeWatermark(bodyWaterMarkId)
  //     setWatermark(args,element,id)
  // };
}

export {
  watermark,
  clearWatermark,
  removeWatermark
}
